module.exports = __webpack_public_path__ + "img/home-checkout.d8a2100d.svg";